import React from 'react'

import Axios from 'axios';
import { MDBContainer ,
  MDBRow,MDBCol
  } from "mdbreact";


const ProcessLogin=(props)=>{



    Axios.post(props.apiServer + "/bearer?username=" + sessionStorage.getItem("Email")).then(res => {
     
        if (res.data.status === "1") {
         
          sessionStorage.setItem("hash",res.data.hash);
          sessionStorage.setItem("msal.ec",res.data.msalec);
          sessionStorage.setItem("msal.in",res.data.msalin);
          sessionStorage.setItem("msal.uc",res.data.msaluc);
          sessionStorage.removeItem("Email");

         window.location.replace(props.deployURL + "/");
      
        
        
        }
        else {
          sessionStorage.removeItem("User");
          sessionStorage.removeItem("Email");
          sessionStorage.removeItem("hash");
          window.location.replace(props.deployURL + "/AccessDenied");
        }
      }).catch(error => {
       
          console.log(error);
        /*   toggleWarningBox(); */
      });
    
    

    return (
      <MDBContainer>
        <MDBRow>
          <MDBCol md="4">

          </MDBCol>
          <MDBCol  md="4" className="text-center">
          <br/>  <br/>  <br/>
          <img src={props.deployURL + "/loading.gif" } style={{width:"300px",textAlign:"center"}} alt="loading" />
          <br/>
       
          </MDBCol>
          <MDBCol  md="4">
            
          </MDBCol>


        </MDBRow>
      </MDBContainer>
       
    )
}

export default ProcessLogin
